import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CollapsablePanel from 'Common/Components/controlled-collapsable-panel/ControlledCollapsablePanel';
import classes from './layout.module.css';
import { makeStyles } from 'utils';

const styles = makeStyles(classes);

function Panel(props) {
    const { open, disabled, renderHeader, title, variant, onToggle, children } = props;

    if (variant === 'collapsable') {
        return (
            <CollapsablePanel open={open} disabled={disabled} onClick={onToggle}>
                <CollapsablePanel.Closed>
                    <div className={classes.panel}>
                        <PanelHeader render={renderHeader} renderArgs={props} title={title} open={open} />
                    </div>
                </CollapsablePanel.Closed>
                <CollapsablePanel.Open>
                    <div className={classes.panel}>
                        <PanelHeader render={renderHeader} renderArgs={props} title={title} open={open} />
                        {children}
                    </div>
                </CollapsablePanel.Open>
            </CollapsablePanel>
        );
    }

    return (
        <Paper elevation={1}>
            <div className={classes.panel}>
                <Typography variant="h3">{title}</Typography>
                {children}
            </div>
        </Paper>
    )
}

Panel.propTypes = {
    disabled: PropTypes.bool,
    open: PropTypes.bool,
    renderHeader: PropTypes.func,
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['default', 'collapsable']),
    onToggle: PropTypes.func,
};

function PanelHeader({ open, render, renderArgs, title }) {
    return (
        <div className={styles('panel__header', open ? null : 'panel__header--closed')}>
            <Typography variant="h3">{title}</Typography>
            { render && render(renderArgs) }
        </div>
    );
}

export default Panel;